<template>

<v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
<div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
  <v-row  class="m-0 mb-1 elevation-1" style="max-height: 2.55rem">
    <v-col md="6" xl="6" class="p-0">
      <v-row class="m-0" style="height: 2.55rem">
        <span style="margin-top: auto;
                     margin-bottom: auto; margin-left: 12px;" class="text-h5">Mitarbeiteranwesenheit</span>
        <!--b-form-radio-group
            style="margin-left: auto;
                    margin-top: auto;
                     margin-bottom: auto;"
            v-model="selectedDate"
            :options="dateOptions"
            button-variant="outline-primary"
            buttons
        ></b-form-radio-group-->
        <button  type="button" :class="{
              'v-icon': true,
              'large': true,
              'notranslate': true,
               'v-data-table__expand-icon': true,
                'v-icon--link': true,
                 'mdi':true,
                  'mdi-chevron-left': true,
                   'theme--light': true,}" style="height: 32px; width: 32px; font-size: 36px;margin-left: auto;
                    margin-top: auto;
                     margin-bottom: auto;" @click="moveDay(-1)"></button>


        <datetime
            style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; margin-left: 12px; margin-right: 12px; margin-top: auto;
                     margin-bottom: auto; width: 250px;"
            v-model="currentDate"
            input-class="form-control text-center"
            input-style="color: black;"
            input-id="date"
            :phrases="datetimeConfig.phrases"
            :format="{ dateStyle: 'full'}"
            :min-datetime="datetimeConfig.minTime"
            @input="onDateChanged"></datetime>
        <button  type="button" :class="{
              'v-icon': true,
              'large': true,
              'notranslate': true,
               'v-data-table__expand-icon': true,
                'v-icon--link': true,
                 'mdi':true,
                  'mdi-chevron-right': true,
                   'theme--light': true,}" style="height: 32px; width: 32px; font-size: 36px;margin-right: 12px;
                    margin-top: auto;
                     margin-bottom: auto;" @click="moveDay(1)"></button>
      </v-row>
    </v-col>
    <v-col md="6" xl="6" class="p-0" style="border-left: 1px solid #e3e3e3">
      <v-row class="m-0" style="height: 2.55rem">
        <span style="margin-top: auto;
                     margin-bottom: auto; margin-left: 12px;" class="text-h5">Tagesablauf: {{selectedMitaName}}</span>
        <v-chip
            style="margin-left: auto;
            margin-right: 12px;
            margin-top: auto;
            margin-bottom: auto;"

            :class="{'soll-ist': true, 'zero': true, 'hidden': dayStatistics.rb === ''}"
        >
          <strong>RB: {{dayStatistics.rb}}</strong>
        </v-chip>
        <v-chip
            style="
            margin-right: 12px;
            margin-top: auto;
            margin-bottom: auto;"

            :class="{'soll-ist': true, 'neg': dayStatistics.soll > dayStatistics.ist, 'pos': dayStatistics.soll <= dayStatistics.ist}"
        >
          <strong>Soll: {{formateHours(dayStatistics.soll)}}&nbsp;&nbsp;|&nbsp;&nbsp;Ist: {{formateHours(dayStatistics.ist)}}</strong>
        </v-chip>
      </v-row>
    </v-col>
    <!--v-col md="6" xl="6" class="p-0">
      <v-row class="m-0" style="height: 2.55rem">
      <span style="margin-top: auto;
                     margin-bottom: auto; margin-left: 24px; font-size: larger"><b>Details</b></span>
      </v-row>
    </v-col-->
  </v-row>

  <v-row class="m-0" style="flex: 0 0 auto;">
    <v-col md="6" xl="6" class="p-0">
      <v-data-table
          dense
          :headers="headers"
          :items="user_times"
          height="calc(100vh - 55px - 2.55rem - 4px)"
          hide-default-footer
          disable-pagination
          single-select
          item-key="user.id"
          fixed-header
          ref="data_table"
          @click:row="onClick"
          no-data-text="Keine Daten vorhanden."

      >
        <template v-slot:item.user.name="{ item }">
          <span><b>{{item.user.name}}</b></span>
        </template>
        <template v-slot:item.ampel="{ item }">
          <div v-if="item.clocked_in.length > 0" style="background-color: green; width: 12px;
    height: 100%;"></div>
          <div v-else-if="item.absences.length > 0" style="background-color: yellow; width: 12px;
    height: 100%;"></div>
          <div v-else style="background-color: red; width: 12px;
    height: 100%;"></div>
        </template>
        <template v-slot:item.clocked_in="{ item }">
          <span v-for="time in item.clocked_in" :key="time">{{ time }}<br></span>
        </template>
        <template v-slot:item.clocked_out="{ item }">
          <span v-for="time in item.clocked_out" :key="time">{{ time }}<br></span>
        </template>
        <template v-slot:item.absences="{ item }">
          <span v-for="absence in item.absences" :key="absence.id">{{ absence.lohn_access }} ({{absence.menge_2 === 0.0 ? absence.menge_1 : absence.menge_2}} {{absence.menge_2 === 0.0 ? 'Std.' : 'Tag'}})<br></span>
        </template>
        <template v-slot:item.ist_zeit="{ item }">
          <span><b>{{ formatIstZeit(item.ist_zeit) }}</b></span>
        </template>
      </v-data-table>
    </v-col>
    <v-col md="6" xl="6" class="p-0">
      <v-card
          outlined
          class="elevation-1"
          style="margin-top: -4px; border-radius: 0px; height: calc(100vh - 55px - 2.55rem)"
      >
        <v-data-table
            dense
            :headers="userDayHeaders"
            :items="time_blocks"
            style="margin-top: 3px"
            height="calc(100vh - 55px - 2.55rem - 4px - 56px)"
            hide-default-footer
            disable-pagination
            item-key="id"
            single-expand
            show-expand
            fixed-header
            no-data-text="Keine Daten vorhanden."
            ref="user_day_table"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-row v-for="child in item.children" :key="child.id" class="m-0">
                <v-col md="6" class="p-1"></v-col>
                <v-col class="p-1"  md="1">
                  <v-icon aria-label="Typ" role="img" aria-hidden="false"
                  >
                    {{child.type === 'FAGE' ? 'mdi-car' : child.type === 'LOHN' ? 'mdi-cash' : 'mdi-toolbox'}}
                  </v-icon>
                </v-col>
                <v-col class="p-1">
                  {{child.type === 'ARTI' ? 'Menge: ' + child.std : 'Dauer: ' + child.std + ' Std.'}}
                </v-col>
                <v-col class="p-1">
                  {{child.title}}
                </v-col>
              </v-row>
            </td>
          </template>
          <template v-slot:item.hinweis="{ item }">
            <button v-if="item.hinweis !== ''" type="button" :class="{
              'v-icon': true,
              'notranslate': true,
                'v-icon--link': true,
                 'mdi':true,
                  'mdi-information': true,
                   'theme--light': true}" @click="showHint(item)"></button>
          </template>
          <template v-slot:item.data-table-expand="{ item }">
            <button v-if="item.children !== null && item.children.length" type="button" :class="{
              'v-icon': true,
              'notranslate': true,
               'v-data-table__expand-icon': true,
                'v-icon--link': true,
                 'mdi':true,
                  'mdi-chevron-down': true,
                   'theme--light': true,
                  'v-data-table__expand-icon--active': currentExpand === item.id}" @click="onExpand(item)"></button>
          </template>
        </v-data-table>
        <v-bottom-navigation style="overflow-y: hidden">
          <v-row class="m-0">
            <v-col></v-col>
            <v-col class="p-1" sm="4" md="4" lg="3" xl="2">
              <v-text-field
                  style="margin-top: 6px"
                  class="long-label"
                  label="Zeitzuschläge:"
                  :value="formateHours(dayStatistics.timeSurcharges) + ' Std.'"
                  prepend-inner-icon="mdi-timeline-clock-outline"
                  hide-details
                  disabled
                  outlined
              ></v-text-field>
            </v-col>
            <v-col class="p-1" sm="4" md="4" lg="3" xl="2">
              <v-text-field
                  style="margin-top: 6px"
                  class="long-label"
                  label="Überstunden geleistet:"
                  :value="formateHours(dayStatistics.uebPerformed) + ' Std.'"
                  prepend-inner-icon="mdi-clock-plus-outline"
                  hide-details
                  disabled
                  outlined
              ></v-text-field>
            </v-col>
            <v-col class="p-1" sm="4" md="4" lg="3" xl="2">
              <v-text-field
                  style="margin-top: 6px"
                  class="long-label"
                  label="Rundungen:"
                  :value="formateHours(dayStatistics.roundings) + ' Std.'"
                  prepend-inner-icon="mdi-sort-clock-descending-outline"
                  hide-details
                  disabled
                  outlined
              ></v-text-field>
            </v-col>

          </v-row>
        </v-bottom-navigation>
      </v-card>
    </v-col>
  </v-row>
  <v-dialog
      v-model="hintDialog"
      max-width="290"
  >
    <v-card>
      <v-card-title class="text-h5">
        Hinweis
      </v-card-title>
      <v-card-text class="text-body-1">
        {{hintText}}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="green darken-1"
            text
            @click="hintDialog = false"
        >
          Schließen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</v-main>

</template>

<script>
import {DateTime as LuxonDateTime} from "luxon";
import _throttle from "lodash/throttle";
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";

export default {
  name: "Anwesenheit",
  data () {
    return {
      headers: [
        {
          text: '',
          value: 'ampel',
          sortable: false,
        },
        {
          text: 'Mitarbeiter',
          value: 'user.name',
        },
        { text: 'Kommt', value: 'clocked_in', sortable: false,},
        { text: 'Pause 1', value: 'pause1', sortable: false, },
        { text: 'Pause 2', value: 'pause2', sortable: false, },
        { text: 'Geht', value: 'clocked_out', sortable: false, },
        { text: 'Ist-Zeit', value: 'ist_zeit', sortable: false, },
        { text: 'Fehlzeit', value: 'absences', sortable: false, },
      ],
      user_times: [],
      currentDate: LuxonDateTime.local().toISO(),
      dateOptions: [
        { text: 'Mo', value: 1 },
        { text: 'Di', value: 2 },
        { text: 'Mi', value: 3 },
        { text: 'Do', value: 4 },
        { text: 'Fr', value: 5 },
        { text: 'Sa', value: 6 },
        { text: 'So', value: 7 },
      ],
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}},
      selectedDate: new Date().getDay() % 7,
      inputActive: false,
      userDayHeaders: [
        {
          text: 'Von',
          value: 'von',
        },
        {
          text: 'Bis',
          value: 'bis',
        },
        {
          text: 'Std',
          value: 'std',
        },
        { text: 'Auftrag', value: 'task', sortable: false,},
        { text: 'Titel', value: 'title', sortable: false, },
        { text: 'Leistung', value: 'legr', sortable: false, },
        { text: 'Hinweis', value: 'hinweis', sortable: false, },
        { text: '', value: 'data-table-expand' },
      ],
      time_blocks: [],
      dayStatistics: {
        rb: '',
        soll: 0.0,
        ist: 0.0,
        timeSurcharges: 0.0,
        uebPerformed: 0.0,
        roundings: 0.0,
      },
      loader: undefined,
      currentExpand: null,
      hintDialog: false,
      hintText: '',
      selectedMitaName: '',
      selectedUserId: '',
    }
  },
  mounted () {
  },
  created() {
    this.showLoader();
    this.$http.get(
        Server_URL_ZK + '/zk/user_presence?date=' + this.currentDate.split('T')[0]
    ).then(this.responseOkGet, this.responseError)
    this.$nextTick(() => {
      this.inputActive = true;
      console.log(this.$refs.data_table)
    });
  },
  methods: {
    showHint(item) {
      this.hintText = item.hinweis;
      this.hintDialog = true;
    },
    onExpand(item) {
      if (this.currentExpand === item.id) {
        this.currentExpand = null;
        this.$refs.user_day_table.expand(item, false)
      } else {
        this.currentExpand = item.id;
        this.$refs.user_day_table.expand(item, true)
      }
    },
    onClick(item, elem) {
      this.selectedUserId = item.user.id;
      this.selectedMitaName = item.user.name;
      elem.select();
      this.showLoader();
      this.$http.get(
          Server_URL_ZK + '/zk/user_presence/'+this.selectedUserId+'?date=' + this.currentDate.split('T')[0]
    ).then(this.responseOkGetUserDay, this.responseError)
    },
    formatIstZeit(ist) {
      let minutes = Math.round(ist * 60);
      let hours = Math.floor(minutes / 60);
      minutes = minutes % 60;
      return hours + ":" + (minutes < 10 ? "0" : "") + minutes;
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200) {
        for (let i = 0; i < response.body.items.length; i++) {
          response.body.items[i].user.name = this.getMitaName(response.body.items[i].user.id);
        }
        this.user_times = response.body.items;
        if (response.body.user_day) {
          this.dayStatistics.rb = response.body.user_day.rb;
          this.dayStatistics.soll = response.body.user_day.user_day.soll;
          this.dayStatistics.ist = response.body.user_day.user_day.ist;
          this.dayStatistics.timeSurcharges = response.body.user_day.time_surcharges;
          this.dayStatistics.uebPerformed = response.body.user_day.ueb_performed;
          this.dayStatistics.roundings = response.body.user_day.roundings;
          this.time_blocks = response.body.user_day.time_blocks;
        }
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkGetUserDay(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.dayStatistics.rb = response.body.rb;
        this.dayStatistics.soll = response.body.user_day.soll;
        this.dayStatistics.ist = response.body.user_day.ist;
        this.dayStatistics.timeSurcharges = response.body.time_surcharges;
        this.dayStatistics.uebPerformed = response.body.ueb_performed;
        this.dayStatistics.roundings = response.body.roundings;
        this.time_blocks = response.body.time_blocks;
      } else {
        window.location = Redirect_500;
      }
    },
    getMitaName(mita) {
      if (mita === null) {
        return null;
      }
      let res = JSON.parse(sessionStorage.getItem(mita));
      if (res === null) {
        return mita;
      }
      return res.first_name + " " + res.surname;
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    onDateChanged(d) {
      if (!this.inputActive) {
        return;
      }
      this.showLoader();
      this.$http.get(
          Server_URL_ZK + '/zk/user_presence?date=' + d.split('T')[0] + "&id="+this.selectedUserId
      ).then(this.responseOkGet, this.responseError)
    },
    moveDay(direction) {
      let d = new Date();
      d.setDate(new Date(this.currentDate).getDate() + direction);
      this.currentDate = d.toISOString();
      this.showLoader();
      this.$http.get(
          Server_URL_ZK + '/zk/user_presence?date=' + this.currentDate.split('T')[0] + "&id="+this.selectedUserId
      ).then(this.responseOkGet, this.responseError)
    },
    formateHours(hours) {
      return Math.floor(hours) + ":" + ("0" + (hours % 1 * 60)).slice(-2);
    },
    roundToDigits (number, digits) {
      const roundTo = Math.pow(10, digits)
      return (Math.round(number * roundTo) / roundTo).toFixed(2)
    },
  }
}
</script>

<style scoped>

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  cursor: pointer;
}

.soll-ist {
  margin-top: 4px;
}

.soll-ist.undefined {
  background-color: rgb(161, 149, 149) !important;
  border-color: rgb(161, 149, 149) !important;
  color: white;
}

.soll-ist.zero {
  background-color: rgb(255, 185, 0) !important;
  border-color: rgb(255, 185, 0) !important;
  color: white;
}

.soll-ist.neg {
  background-color: rgb(255, 69, 0)!important;
  border-color: rgb(255, 69, 0)!important;
  color: white;
}

.soll-ist.pos {
  background-color: rgb(1, 109, 3)!important;
  border-color: rgb(1, 109, 3)!important;
  color: white;
}

.theme--light.v-label {
  color: black;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

::v-deep .theme--light.v-icon.v-icon.v-icon--disabled {
  color: rgb(84, 84, 84) !important;
}

.hidden {
  visibility: hidden;
}

::v-deep .v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0 4px 4px -6px rgba(50, 50, 50, 0.75), inset 0 -4px 4px -6px rgba(50, 50, 50, 0.75)
}
</style>
